import type { CheckedDownloadItem, DownloadTreeNode } from '~/types/download'
import { isBookPayload } from '~/utils/download/isBookPayload'

export function normalizeDownloadId(id?: string | null) {
  return id?.toLocaleLowerCase?.() ?? null
}

export function createCheckedItemFromNode(node: DownloadTreeNode): CheckedDownloadItem | null {
  const id = node.downloadId ?? node.id
  if (!id) {
    return null
  }

  return {
    id,
    downloadId: node.downloadId,
    ezMainNodeId: node.ezMainNodeId,
    tocIndex: node.tocIndex,
    type: node.type,
    payload: node.payload,
  }
}

export function findTocNodeBySelectionKey(nodes: DownloadTreeNode[], key: string): DownloadTreeNode | null {
  for (const node of nodes) {
    const idKey = normalizeDownloadId(node.id)
    const downloadKey = normalizeDownloadId(node.downloadId)
    if (idKey === key || downloadKey === key) {
      return node
    }

    const nested = findTocNodeBySelectionKey(node.children ?? [], key)
    if (nested) {
      return nested
    }
  }

  return null
}

export function findTocNodeIdBySelectionKey(nodes: DownloadTreeNode[], key: string): string | null {
  return findTocNodeBySelectionKey(nodes, key)?.id ?? null
}

export function findFirstBookNode(nodes: DownloadTreeNode[]): DownloadTreeNode | null {
  for (const node of nodes) {
    if (isBookPayload(node.payload)) {
      return node
    }

    const nested = findFirstBookNode(node.children ?? [])
    if (nested) {
      return nested
    }
  }

  return null
}

export function findFirstSelectableBookNode(nodes: DownloadTreeNode[]): DownloadTreeNode | null {
  for (const node of nodes) {
    if (isBookPayload(node.payload) && Boolean(node.payload.pageNumber)) {
      return node
    }

    const nested = findFirstSelectableBookNode(node.children ?? [])
    if (nested) {
      return nested
    }
  }

  return null
}
